const SURVEY_STATE = {
  inProgress: 'in_progress',
  expired: 'expired',
};

export default SURVEY_STATE;
